function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "food-apple");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Sense-Mobile-#1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "panel-aktywny",
  transform: "translate(-293.000000, -299.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(16.000000, 285.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "food-apple",
  transform: "translate(277.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,10 C22,13 17,22 15,22 C13,22 13,21 12,21 C11,21 11,22 9,22 C7,22 2,13 4,10 C6,7 9,7 11,8 L11,5 C5.38,8.07 4.11,3.78 4.11,3.78 C4.11,3.78 6.77,0.19 11,5 L11,3 L13,3 L13,8 C15,7 18,7 20,10 Z",
  id: "Path",
  fill: "#00346A",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
})))));

var SvgFoodApple = function SvgFoodApple(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoodApple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/food-apple.fe67ae65.svg";
export { ForwardRef as ReactComponent };